import { render, staticRenderFns } from "./PastaInfo.vue?vue&type=template&id=5c82aa42"
import script from "./PastaInfo.vue?vue&type=script&lang=js"
export * from "./PastaInfo.vue?vue&type=script&lang=js"
import style0 from "./PastaInfo.vue?vue&type=style&index=0&id=5c82aa42&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports